import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58b237e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-box u-scrollbar" }
const _hoisted_2 = {
  key: 0,
  class: "history"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "历史搜索", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M160 256H96a32 32 0 0 1 0-64h256V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64h-64v672a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V256zm448-64v-64H416v64h192zM224 896h576V256H224v640zm192-128a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32zm192 0a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32z"
  })
], -1))
const _hoisted_6 = { class: "trending" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "热搜", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "data-v-5fe91717": "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-v-5fe91717": "",
    d: "M12.8 5.2C13.9532 6.46 14.8 8.2 14.8 10C14.7039 12.8937 12.6843 15.1706 9.97973 15.8159C10.359 12.3442 7.77588 9.35406 7.77588 9.35406C7.77588 9.35406 7.99512 13.7064 6.79514 15.8104C4.03715 15.1428 2 12.7806 2 9.8C2 7.776 2.9336 5.9728 4.4 4.8C5.8608 3.7056 6.8 1.9656 6.8 0C9.684 0.4368 11.894 2.9264 11.894 5.932C11.894 6.5012 11.746 7.0652 11.6 7.6C12.1264 6.9024 12.6184 6.0876 12.8 5.2Z",
    fill: "#F53F3F"
  })
], -1))
const _hoisted_10 = { class: "hot-list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "trending-text u-ellipsis" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trending-mark" }, null, -1))

import { ref } from 'vue'
import { DataApi } from './search.vue'

interface Props {
  data: DataApi
}


export default /*#__PURE__*/_defineComponent({
  __name: 'card-box',
  props: {
    data: null
  },
  emits: ["onClose", "submit", "onClear"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onClose', val: string): void
  (e: 'submit', val: string): void
  (e: 'onClear'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: DataApi
}





return (_ctx: any,_cache: any) => {
  const _component_u_icon = _resolveComponent("u-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.data.historySearchList.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_el_button, {
              class: "clear",
              link: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClear')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_u_icon, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createTextVNode(" 清空 ")
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.historySearchList, (item, id) => {
            return (_openBlock(), _createBlock(_component_el_tag, {
              key: id,
              type: (item.type as any),
              closable: "",
              onClose: ($event: any) => (_ctx.$emit('onClose', item.name)),
              onClick: ($event: any) => (_ctx.$emit('submit', item.name))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["type", "onClose", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_u_icon, { style: {"margin":"0 6px"} }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.hotSearchList, (item, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "hot-item",
            onClick: ($event: any) => (_ctx.$emit('submit', item))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['trending-rank', { 'trending-rank-top': key < 3 }])
            }, _toDisplayString(key + 1), 3),
            _createElementVNode("div", _hoisted_12, _toDisplayString(item), 1),
            _hoisted_13
          ], 8, _hoisted_11))
        }), 128))
      ])
    ])
  ], 512)), [
    [_vShow, __props.data.cardVisible]
  ])
}
}

})